/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:460px){.app-wizard-step[_ngcontent-%COMP%]{min-width:100%}.app-wizard-step[_ngcontent-%COMP%] > app-endusers-table[_ngcontent-%COMP%]{width:100%;margin-right:0}}"];
export { styles as styles };
